<template>
<div id="app">
    <el-container>
        <el-main>
            <img src="logo.png" alt="logo" style="width: 100%">
            <el-form label-position="right" label-width="100px" :model="joinForm" size="medium">
                <el-form-item label="Room ID">
                    <el-input placeholder="Enter room id" v-model="joinForm.channelName"></el-input>
                </el-form-item>
                <el-form-item label="Name">
                    <el-input placeholder="Enter your name" v-model="joinForm.name"></el-input>
                </el-form-item>
                <el-form-item class="form-buttons" label-width="0">
                    <el-button type="primary" v-on:click="joinRoom">Join Room</el-button>
                </el-form-item>
                <el-link @click="goToAdmin" class="forgot-password">Go to Admin Dashboard</el-link>
            </el-form>
        </el-main>
    </el-container>
</div>
</template>

<script>
import {
    mapState,
} from "vuex";

export default {
    name: 'Home',
    data() {
        return {
            joinForm: {
                channelName: '',
            }
        }
    },
    methods: {
        joinRoom: function () {
            this.$store.commit("mainRoomConfig/updateMainRoomName", this.joinForm.channelName);
            this.$router.push({
                name: "Join",
                params: {
                    roomName: this.joinForm.channelName.toLowerCase(),
                    name: this.joinForm.name,
                }
            });
        },
        goToAdmin(){
            this.$router.push({
                name: "AdminDashboard", 
            })
        }
    },
    computed: {
        ...mapState({
            profile: (state) => state.user.profile
        }),
    },
}
</script>

<style>
#app {
    text-align: center;
    color: #2c3e50;
    height: 100%;
}

.el-header {
    text-align: center;
    font-size: xx-large;
}
</style>

<style scoped>
.el-main {
    width: 500px;
    min-width: 500px;
    max-width: 500px;
    margin: 55px auto;
    height: 100%;
}

@media (max-width: 500px) {
    .el-main {
        width: 100%;
        min-width: 100%;
        max-width: 100%;
        height: auto;
    }
}

.form-buttons {
    text-align: center;
}

.el-container {
    background-color: #1C1C29;
    height: 100%;
}

>>>input.el-input__inner,
>>>.el-input.is-disabled .el-input__inner {
    background: #393752;
    border-radius: 3px;
    height: 32px;
    border: none;
    color: #E7E6FA;
}

>>>.el-input .el-input__inner{
    color: #E7E6FA;
}
>>>.el-input .el-input__inner::-webkit-input-placeholder { /* Edge */
    color: rgba(231, 230, 250, 0.4);
}

>>>.el-input .el-input__inner:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: rgba(231, 230, 250, 0.4);
}

>>>.el-input .el-input__inner::placeholder {
    color: rgba(231, 230, 250, 0.4);
}

>>>label.el-form-item__label,
>>>span.el-link--inner {
    color: #E7E6FA;
}
</style>
